export const channelPartnerList = "CHANNEL_PARTNER_LIST";
export const states = "STATES";
export const cities = "CITIES";
export const channelPartnerDashboard = "CHANNEL_PARTNER_DASHBOARD";
export const channelPartnerEnrolledCourseList = "CHANNEL_PARTNER_ENROLLED_COURSE_LIST";
export const paymentApprovalRequestList = "PAYMENT_APPROVAL_REQUEST_LIST";

